import React from 'react';
import moment from 'moment';

import CustomDateRange from 'Shared/components/CustomDateRange/CustomDateRange';

import './ExportGoalDatePicker.scss';

type Props = {
  dateRange: {
    startRange: moment.Moment;
    endRange: moment.Moment;
  };
  onRangeChange: Function;
};

function ExportGoalDatePicker({ dateRange, onRangeChange }: Props) {
  return (
    <div className="ExportGoalDatePicker">
      <div className="ExportGoalDatePicker__title mb-2">Choose time frame</div>
      <CustomDateRange
        customArrowIcon={<div>to</div>}
        startRange={dateRange.startRange}
        endRange={dateRange.endRange}
        onRangeChange={onRangeChange}
        withPortal
      />
    </div>
  );
}

export default ExportGoalDatePicker;
